const RestrictionsDecorate = require('../../../../facade/restrictions/decorate');

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    const restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    let type = selection.type;
    if (type === 'sticker') type = 'vector';
    const getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );
    const permissionName = type + '_replace';

    const basicRestrictions = getRestrictions('basic');
    if (!basicRestrictions[0] ||
      (_.isUndefined(basicRestrictions[0][permissionName]))) {
      basicRestrictions[0] = restrictionsFacade.getAllDefaultPermissions();
    }

    const canReplace = basicRestrictions[0][permissionName];

    return getRestrictions('colors').length ||
      getRestrictions('colors-library').length ||
      (canReplace && (selection.type === 'logo' || selection.type === 'icon' || selection.type === 'sticker'));
  }
}, { haveOptions: function () { return false; } });
